import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

function escapeRegex(string) {
  return string.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&");
}

if (SENTRY_DSN) {
  console.log("Setting up Sentry");
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    environment: import.meta.env.VITE_ENV || "development",
    tracesSampleRate: 0.1,
    tracePropagationTargets: [
      "localhost",
      new RegExp(escapeRegex(import.meta.env.VITE_API_URL)),
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
